import { getUsers } from 'store/entities/users/actions';
import { getWildcardMask } from 'store/entities/users/utils';
import { call, put, takeLatest, select } from 'typed-redux-saga';
import { withBackendErrorHandler } from 'store/utils/sagas/withBackendErrorHandler';
import { usersApi } from 'store/entities/users/api';
import { IGetUserRequest, UserType } from 'store/entities/users/model';
import {
    getMoreEmployeesAction,
    initialLoadEmployees, refreshEmployees,
    setEmployeesFilter,
} from 'modules/users/employees/store/actions';
import {
    employeesSelectors,
    pageSize,
    selectEmployeeFilter,
} from 'modules/users/employees/store/selectors';

export function* getMoreUsersSaga() {
    const nextPageToLoad = yield* select(employeesSelectors.selectNextPage);
    const filter = yield* select(selectEmployeeFilter);
    const request: IGetUserRequest = {
        page_size: pageSize,
        page_number: nextPageToLoad,
        search: filter.search ? getWildcardMask(filter.search) : undefined,
        client_id: filter.client?.id || undefined,
        status: filter.status || undefined,
        user_type: UserType.Employee,
    };
    const getUsersResponse = yield* call(usersApi.getUsers, request);
    yield put(getMoreEmployeesAction.success(getUsersResponse));
    yield put(getUsers.success(getUsersResponse.users));
}

function* getMoreUsersSagaWatcher() {
    yield* takeLatest(
        [
            getMoreEmployeesAction.initType,
            initialLoadEmployees.action,
            setEmployeesFilter.action,
            refreshEmployees.action,
        ],
        withBackendErrorHandler(
            getMoreUsersSaga,
            getMoreEmployeesAction.error,
            'Unable to get employees.',
        ),
    );
}

export default [
    getMoreUsersSagaWatcher,
];
